import styled from 'styled-components';

export const Container = styled.div`
  flex: 1;
  min-height: 0;
`;

export const TimelineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
